module.exports = __webpack_public_path__ + "img/multiple-real-estate-listings.2b0150aa.png";